import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import type { Operand } from '~/lib/filters/operands';

/** Operand dropdown shared by the filter-builder leaves; `invalid` flags a required-but-missing operand. */
export function OperandSelect({
	value,
	onChange,
	operands,
	invalid
}: {
	value?: string;
	onChange: (op: string) => void;
	operands: Operand[];
	invalid?: boolean;
}) {
	const { t } = useTranslation();
	return (
		<Select value={value ?? undefined} onValueChange={onChange}>
			<SelectTrigger className={cn('h-9 w-auto min-w-28', invalid && 'border-destructive')} aria-invalid={invalid || undefined}>
				<SelectValue placeholder={t('catalog.filters.operand')} />
			</SelectTrigger>
			<SelectContent>
				{operands.map(op => (
					<SelectItem key={op.id} value={op.id}>
						{op.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
